import Videos from './videos'

export default Videos
